import { render } from "./SearchTop.vue?vue&type=template&id=16cdc8c4&scoped=true"
import script from "./SearchTop.vue?vue&type=script&lang=js"
export * from "./SearchTop.vue?vue&type=script&lang=js"

import "./SearchTop.vue?vue&type=style&index=0&id=16cdc8c4&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-16cdc8c4"

export default script